/*
 * /document-writer — ядро редактора.
 *
 * Документ — один contenteditable-лист (#dwDoc). Всё, что поверх него
 * (промежутки между страницами, номера страниц, подсветка поиска и полей
 * шаблона), живёт ВНЕ редактируемого узла или в CSS: в документ не вставляется
 * ни одного служебного узла, поэтому сохранённый и выгруженный HTML — ровно то,
 * что человек написал.
 *
 * Здесь: настройки документа и пресеты оформления, картинки как байты (Blob,
 * в документе — blob:-адреса), своя история отмены (снимки HTML + путь каретки),
 * команды форматирования, нормализация после браузерных команд, сериализация.
 * Клавиатура и вставка — input.js, интерфейс — ui.js, страницы — paginate.js,
 * файлы — io.js / export-*.js (грузятся по первому требованию).
 *
 * Почему своя история, а не родной Ctrl+Z браузера: редактор меняет документ и
 * сам — кегль в pt, межстрочный интервал, операции с таблицей, «заменить всё»,
 * шаблон, ответ ИИ. Изменение DOM из кода не попадает в стек браузера и ломает
 * его соседние шаги (Ctrl+Z после такой правки отменяет не то или ничего). Один
 * стек снимков отменяет всё одинаково и возвращает каретку на место.
 */
(function () {
'use strict';

var C = window.__DW;
var root = document.getElementById('dw');
if (!C || !root || window.DW) return;

var $ = function (id) { return document.getElementById(id); };
var doc = $('dwDoc');
var L = C.L || {};

function t(k, r) {
    var s = L[k];
    if (s == null) return k;
    s = String(s);
    if (r) for (var x in r) if (Object.prototype.hasOwnProperty.call(r, x)) s = s.split(':' + x).join(String(r[x]));
    return s;
}
function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
}
function fmtNum(n) {
    try { return Number(n).toLocaleString(C.locale); } catch (e) { return String(n); }
}

/* ── события ────────────────────────────────────────────────────────────── */
var bus = {};
function on(ev, fn) { (bus[ev] = bus[ev] || []).push(fn); }
function emit(ev, a, b) {
    var l = bus[ev]; if (!l) return;
    for (var i = 0; i < l.length; i++) { try { l[i](a, b); } catch (e) { report(e, 'dw_' + ev); } }
}
function report(e, ctx) {
    try {
        if (window.__aeToolError) window.__aeToolError({ slug: 'document-writer', msg: String(e && (e.message || e) || '').slice(0, 200), ctx: ctx || 'dw' });
    } catch (_) {}
    try { console.error('[document-writer]', ctx, e); } catch (_) {}
}
function track(f, d) {
    try {
        var p = { slug: 'document-writer', f: f };
        if (d) for (var k in d) p[k] = d[k];
        if (window.__ae) window.__ae('feature_use', p);
    } catch (_) {}
}
function toast(msg, type, opts) { try { if (window.__toast) window.__toast(msg, type || 'success', opts); } catch (_) {} }

/* ── единицы ────────────────────────────────────────────────────────────── */
var MM = 96 / 25.4, PT = 96 / 72;
var PAPER = { a4: [210, 297], a5: [148, 210], letter: [215.9, 279.4], legal: [215.9, 355.6] };
var FONTS = {};
(C.fonts || []).forEach(function (f) { FONTS[f.id] = f; });

/* ── пресеты оформления ──────────────────────────────────────────────────
   Цифры — из самих стандартов (проверено 08.10.2026):
   · ГОСТ 7.32-2017 (отчёт о НИР — на нём стоят требования к курсовым и
     рефератам): поля 30/15/20/20 мм, 12–14 pt, интервал 1,5, абзацный отступ
     1,25 см, по ширине, номер страницы внизу по центру, титульный без номера.
   · ГОСТ Р 7.0.97-2025 (организационно-распорядительные документы, действует
     с 18.08.2025, заменил редакцию 2016): поля не менее 20 мм (левое 30 мм для
     документов долгого хранения), правое не менее 10 мм; 12–14 pt; интервал
     1–1,5; отступ 1,25 см; номер страницы — сверху по центру со второй.
   · APA 7 / MLA 9: 12 pt, двойной интервал, поля 1″, отступ 0,5″, номер
     сверху справа.
   · DIN 5008:2020 (немецкое деловое письмо): поле слева 25 мм, справа ≥ 15 мм
     (берём 20), одинарный интервал, абзацы через пустую строку (~12 pt). */
var PRESETS = {
    standard:      { font: 'tnr', size: 14, lh: 1.15, pafter: 6, findent: 0, align: 'left', m: { t: 20, b: 20, l: 30, r: 15 }, pnum: 'none', pnFirst: false },
    gost_study:    { font: 'tnr', size: 14, lh: 1.5, pafter: 0, findent: 1.25, align: 'justify', m: { t: 20, b: 20, l: 30, r: 15 }, pnum: 'bc', pnFirst: true },
    gost_business: { font: 'tnr', size: 14, lh: 1, pafter: 0, findent: 1.25, align: 'justify', m: { t: 20, b: 20, l: 30, r: 10 }, pnum: 'tc', pnFirst: true },
    compact:       { font: 'arial', size: 11, lh: 1, pafter: 4, findent: 0, align: 'left', m: { t: 15, b: 15, l: 15, r: 15 }, pnum: 'none', pnFirst: false },
    word:          { font: 'calibri', size: 11, lh: 1.08, pafter: 8, findent: 0, align: 'left', m: { t: 25.4, b: 25.4, l: 25.4, r: 25.4 }, pnum: 'none', pnFirst: false },
    apa:           { font: 'tnr', size: 12, lh: 2, pafter: 0, findent: 1.27, align: 'left', m: { t: 25.4, b: 25.4, l: 25.4, r: 25.4 }, pnum: 'tr', pnFirst: false },
    mla:           { font: 'tnr', size: 12, lh: 2, pafter: 0, findent: 1.27, align: 'left', m: { t: 25.4, b: 25.4, l: 25.4, r: 25.4 }, pnum: 'tr', pnFirst: false },
    business:      { font: 'arial', size: 11, lh: 1.15, pafter: 10, findent: 0, align: 'left', m: { t: 25.4, b: 25.4, l: 25.4, r: 25.4 }, pnum: 'none', pnFirst: false },
    din5008:       { font: 'arial', size: 11, lh: 1, pafter: 12, findent: 0, align: 'left', m: { t: 27, b: 20, l: 25, r: 20 }, pnum: 'none', pnFirst: false },
    // ABNT NBR 14724:2024 (Бразилия): поля сверху и слева 3 см, снизу и справа 2 см, 12 pt,
    // интервал 1,5, номер сверху справа, на обложке не виден.
    abnt:          { font: 'tnr', size: 12, lh: 1.5, pafter: 0, findent: 1.25, align: 'justify', m: { t: 30, b: 20, l: 30, r: 20 }, pnum: 'tr', pnFirst: true },
    // Skripsi/makalah (Индонезия): единого стандарта нет, типичные требования вузов —
    // поля 4/3/4/3 см, Times New Roman 12, двойной интервал, номер сверху справа.
    // ДСТУ 3008:2015 (Украина, отчёты — курсовые, рефераты): поля ≥ 20/20/25/10 мм,
    // Times New Roman 14, интервал 1,5, абзац 5 знаков, номер сверху справа, титульный без номера.
    dstu_study:    { font: 'tnr', size: 14, lh: 1.5, pafter: 0, findent: 1.25, align: 'justify', m: { t: 20, b: 20, l: 25, r: 10 }, pnum: 'tr', pnFirst: true },
    // ДСТУ 4163:2020 (Украина, организационно-распорядительные документы): поля 30/10/20/20 мм,
    // 12–14 pt, интервал 1–1,5, абзацный отступ 10 мм, номер сверху по центру со второй страницы.
    dstu_business: { font: 'tnr', size: 14, lh: 1, pafter: 0, findent: 1, align: 'justify', m: { t: 20, b: 20, l: 30, r: 10 }, pnum: 'tc', pnFirst: true },
    skripsi:       { font: 'tnr', size: 12, lh: 2, pafter: 0, findent: 1.27, align: 'justify', m: { t: 40, b: 30, l: 40, r: 30 }, pnum: 'tr', pnFirst: true }
};
var PRESET_ORDER = C.locale === 'uk' ? ['standard', 'dstu_study', 'dstu_business', 'word', 'compact']
    : C.gost ? ['standard', 'gost_study', 'gost_business', 'word', 'compact']
    : ({
        de: ['word', 'din5008', 'apa', 'mla', 'compact'],
        pt: ['word', 'abnt', 'apa', 'business', 'compact'],
        id: ['word', 'skripsi', 'apa', 'business', 'compact']
    }[C.locale] || ['word', 'apa', 'mla', 'business', 'compact']);
var DEFAULT_PRESET = C.gost ? 'standard' : 'word';

function presetSettings(id) {
    var p = PRESETS[id] || PRESETS[DEFAULT_PRESET];
    return {
        preset: id,
        paper: 'a4', orient: 'portrait',
        m: { t: p.m.t, b: p.m.b, l: p.m.l, r: p.m.r },
        font: p.font, size: p.size, lh: p.lh, pafter: p.pafter, findent: p.findent, align: p.align,
        pnum: p.pnum, pnFirst: p.pnFirst
    };
}

var S = {
    set: presetSettings(DEFAULT_PRESET),
    view: 'page',          // page | flow
    zoom: 1,
    zoomMode: 'fit',       // fit | fixed
    darkPaper: false,
    autoTypo: true,
    composing: false,
    ready: false,
    dirty: false
};

function pageSizePx(set) {
    set = set || S.set;
    var p = PAPER[set.paper] || PAPER.a4;
    var w = p[0], h = p[1];
    if (set.orient === 'landscape') { var x = w; w = h; h = x; }
    return { w: w * MM, h: h * MM, wmm: w, hmm: h };
}

/* Настройки → CSS-переменные листа. Тот же набор читают paginate.js и
   выгрузки — источник один. */
function applySettings(silent) {
    var s = S.set, sz = pageSizePx(s);
    var f = FONTS[s.font] || FONTS.tnr || { css: 'serif' };
    var st = doc.style;
    st.setProperty('--pw', sz.w.toFixed(2) + 'px');
    st.setProperty('--ph', sz.h.toFixed(2) + 'px');
    st.setProperty('--mt', (s.m.t * MM).toFixed(2) + 'px');
    st.setProperty('--mb', (s.m.b * MM).toFixed(2) + 'px');
    st.setProperty('--ml', (s.m.l * MM).toFixed(2) + 'px');
    st.setProperty('--mr', (s.m.r * MM).toFixed(2) + 'px');
    st.setProperty('--ff', f.css);
    st.setProperty('--fs', s.size + 'pt');
    st.setProperty('--lh', String(s.lh));
    st.setProperty('--ps', s.pafter + 'pt');
    st.setProperty('--ti', s.findent + 'cm');
    st.setProperty('text-align', s.align === 'justify' ? 'justify' : 'start');
    var paper = $('dwPaper');
    if (paper) {
        paper.style.width = S.view === 'page' ? sz.w.toFixed(2) + 'px' : '';
        paper.style.setProperty('--mr', (s.m.r * MM).toFixed(2) + 'px');
        paper.style.setProperty('--ml', (s.m.l * MM).toFixed(2) + 'px');
    }
    var pp = $('dwPrintPage');
    if (pp) {
        // Печать браузером: те же поля и размер листа, что на экране.
        var printCss = '@page{size:' + sz.wmm.toFixed(1) + 'mm ' + sz.hmm.toFixed(1) + 'mm;margin:' +
            s.m.t + 'mm ' + s.m.r + 'mm ' + s.m.b + 'mm ' + s.m.l + 'mm}' +
            '.dw-doc{font-size:' + s.size + 'pt!important}';
        pp.textContent = printCss;
    }
    if (!silent) emit('settings', s);
}

/* ── картинки: байты, а не data-URL ──────────────────────────────────────
   В документе картинка — blob:-адрес; сам Blob лежит здесь. Снимки истории
   остаются маленькими (адрес, а не мегабайты base64), черновик хранит байты
   (контракт __toolDraft: files — Blob), выгрузки читают их отсюда. */
var IMG = {};   // url → Blob
function addImage(blob) {
    var url = URL.createObjectURL(blob);
    IMG[url] = blob;
    return url;
}
function imageBlob(url) {
    if (IMG[url]) return Promise.resolve(IMG[url]);
    if (/^data:/i.test(url)) {
        try {
            var parts = url.split(','), mime = (parts[0].match(/data:([^;,]+)/) || [])[1] || 'image/png';
            var bin = atob(parts[1] || ''), u8 = new Uint8Array(bin.length);
            for (var i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
            return Promise.resolve(new Blob([u8], { type: mime }));
        } catch (e) { return Promise.resolve(null); }
    }
    return fetch(url).then(function (r) { return r.ok ? r.blob() : null; }).catch(function () { return null; });
}
/* Чужая картинка (вставка из буфера с data:-адресом, из файла) — к нашим байтам,
   уменьшенная до разумного: 2400 px по длинной стороне хватает на печать A4 в
   200 dpi, а 12-мегапиксельное фото с телефона больше не весит 6 МБ в каждом
   снимке и черновике. */
var MAX_IMG = 2400;
function adoptImageFile(file) {
    return new Promise(function (resolve) {
        if (!file || !/^image\//.test(file.type || '')) { resolve(null); return; }
        if (/gif|svg/.test(file.type) || file.size < 400 * 1024) { resolve(addImage(file)); return; }
        var url = URL.createObjectURL(file), img = new Image();
        img.onload = function () {
            var w = img.naturalWidth, h = img.naturalHeight, k = Math.min(1, MAX_IMG / Math.max(w, h));
            if (k >= 1 && file.size < 2.5 * 1024 * 1024) { URL.revokeObjectURL(url); resolve(addImage(file)); return; }
            var c = document.createElement('canvas');
            c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(h * k));
            var ctx = c.getContext('2d');
            var png = /png|webp/.test(file.type);
            if (!png) { ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height); }
            ctx.drawImage(img, 0, 0, c.width, c.height);
            URL.revokeObjectURL(url);
            var done = function (b) { resolve(addImage(b || file)); };
            window.__canvasBlob(c, png ? 'image/png' : 'image/jpeg', 0.88).then(done, function () { done(null); });
        };
        img.onerror = function () { URL.revokeObjectURL(url); resolve(null); };
        img.src = url;
    });
}

/* ── выделение ──────────────────────────────────────────────────────────── */
function selRange() {
    var s = window.getSelection();
    if (!s || !s.rangeCount) return null;
    var r = s.getRangeAt(0);
    return doc.contains(r.commonAncestorContainer) ? r : null;
}
var lastRange = null;
document.addEventListener('selectionchange', function () {
    var r = selRange();
    if (r) lastRange = r.cloneRange();
    emit('selection', r);
});
/* Вернуть выделение в документ перед командой: меню и поля ввода в
   всплывающих панелях забирают фокус, а команда должна лечь туда, где оно
   было. preventScroll — страница под человеком не прыгает. */
function restoreRange() {
    var r = selRange();
    if (r && document.activeElement === doc) return r;
    try { doc.focus({ preventScroll: true }); } catch (e) { doc.focus(); }
    var s = window.getSelection();
    if (lastRange && doc.contains(lastRange.commonAncestorContainer)) {
        s.removeAllRanges(); s.addRange(lastRange);
        return lastRange;
    }
    var nr = document.createRange();
    nr.selectNodeContents(doc.lastElementChild || doc);
    nr.collapse(false);
    s.removeAllRanges(); s.addRange(nr);
    return nr;
}
/* Путь до узла от корня документа — каретка переживает возврат снимка, потому
   что HTML снимка совпадает с тем, по которому путь считали. */
function pathOf(node) {
    var p = [];
    while (node && node !== doc) {
        var i = 0, n = node;
        while ((n = n.previousSibling)) i++;
        p.unshift(i);
        node = node.parentNode;
    }
    return node === doc ? p : null;
}
function nodeAt(path) {
    var n = doc;
    for (var i = 0; i < path.length; i++) {
        if (!n || !n.childNodes[path[i]]) return null;
        n = n.childNodes[path[i]];
    }
    return n;
}
function saveSel() {
    var r = selRange();
    if (!r) return null;
    var a = pathOf(r.startContainer), b = pathOf(r.endContainer);
    if (!a || !b) return null;
    return { a: a, ao: r.startOffset, b: b, bo: r.endOffset };
}
function loadSel(x, focus) {
    if (!x) return false;
    var a = nodeAt(x.a), b = nodeAt(x.b);
    if (!a || !b) return false;
    try {
        var r = document.createRange();
        r.setStart(a, Math.min(x.ao, a.nodeType === 3 ? a.length : a.childNodes.length));
        r.setEnd(b, Math.min(x.bo, b.nodeType === 3 ? b.length : b.childNodes.length));
        if (focus !== false) { try { doc.focus({ preventScroll: true }); } catch (e) { doc.focus(); } }
        var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
        lastRange = r.cloneRange();
        return true;
    } catch (e) { return false; }
}

/* ── история ────────────────────────────────────────────────────────────── */
var H = { stack: [], idx: -1, timer: 0, bytes: 0 };
var H_MAX = 120, H_BYTES = 40e6;
function histTop() { return H.stack[H.idx]; }
function commit() {
    clearTimeout(H.timer); H.timer = 0;
    var html = doc.innerHTML;
    var top = histTop();
    if (top && top.html === html) { top.sel = saveSel() || top.sel; return false; }
    H.stack.length = H.idx + 1;
    H.stack.push({ html: html, sel: saveSel(), set: JSON.stringify(S.set) });
    H.bytes += html.length * 2;
    while ((H.stack.length > H_MAX || H.bytes > H_BYTES) && H.stack.length > 2) {
        H.bytes -= H.stack[0].html.length * 2;
        H.stack.shift();
    }
    H.idx = H.stack.length - 1;
    emit('history');
    return true;
}
function scheduleCommit(ms) {
    clearTimeout(H.timer);
    H.timer = setTimeout(commit, ms == null ? 650 : ms);
}
function restoreState(st) {
    doc.innerHTML = st.html;
    if (st.set && st.set !== JSON.stringify(S.set)) {
        try { S.set = JSON.parse(st.set); applySettings(); } catch (e) {}
    }
    loadSel(st.sel);
    afterChange('history');
}
function undo() {
    if (H.timer) commit();
    if (H.idx <= 0) return false;
    H.idx--;
    restoreState(H.stack[H.idx]);
    emit('history');
    return true;
}
function redo() {
    if (H.timer) commit();
    if (H.idx >= H.stack.length - 1) return false;
    H.idx++;
    restoreState(H.stack[H.idx]);
    emit('history');
    return true;
}
function resetHistory() {
    clearTimeout(H.timer); H.timer = 0;
    H.stack = []; H.idx = -1; H.bytes = 0;
    commit();
}
function canUndo() { return H.idx > 0 || !!H.timer; }
function canRedo() { return H.idx < H.stack.length - 1; }

/* ── нормализация ───────────────────────────────────────────────────────── */
var BLOCKS = /^(P|H1|H2|H3|H4|H5|H6|UL|OL|TABLE|BLOCKQUOTE|HR|DIV|PRE|FIGURE)$/;
var KEYWORD_SIZE = /xxx-large|-webkit-xxx-large/;
function isEmptyDoc() {
    var txt = doc.textContent.replace(/[\u200b\u00a0\s]/g, '');
    return !txt && !doc.querySelector('img,table,hr,.dw-pb');
}
function normalize() {
    // <font> из старых команд браузера → span с тем же смыслом.
    doc.querySelectorAll('font').forEach(function (f) {
        var sp = document.createElement('span');
        if (f.color) sp.style.color = f.color;
        if (f.face) sp.style.fontFamily = f.face;
        while (f.firstChild) sp.appendChild(f.firstChild);
        f.parentNode.replaceChild(sp, f);
    });
    // Кегль: команда браузера умеет только 7 ступеней, мы — точный pt.
    // Команда может повесить стиль и на <b>/<i>, а не только на span.
    if (S.pendingSize) {
        doc.querySelectorAll('[style*="font-size"]').forEach(function (el) {
            if (KEYWORD_SIZE.test(el.style.fontSize)) el.style.fontSize = S.pendingSize + 'pt';
        });
    }
    doc.querySelectorAll('span[style]').forEach(function (sp) {
        var st = sp.style;
        if (st.backgroundColor === 'transparent' || st.backgroundColor === 'rgba(0, 0, 0, 0)') st.removeProperty('background-color');
        if (st.fontSize && KEYWORD_SIZE.test(st.fontSize)) st.removeProperty('font-size');
        // Chrome переносит в span «вычисленный» стиль соседнего текста при
        // склейке абзацев — line-height и цвет по умолчанию в документе лишние.
        st.removeProperty('line-height');
        if (/^(rgb\(0, 0, 0\)|#000000|black)$/.test(st.color) && !sp.closest('[style*="color"]:not(span)')) {
            // цвет «авто» остаётся авто: тёмный лист и печать решают сами
            st.removeProperty('color');
        }
        if (!sp.getAttribute('style').trim()) sp.removeAttribute('style');
        if (!sp.attributes.length) {
            while (sp.firstChild) sp.parentNode.insertBefore(sp.firstChild, sp);
            sp.parentNode.removeChild(sp);
        }
    });
    // Голый текст и div верхнего уровня → абзацы.
    var kids = Array.prototype.slice.call(doc.childNodes);
    var run = null;
    kids.forEach(function (n) {
        if (n.nodeType === 3 || (n.nodeType === 1 && !BLOCKS.test(n.tagName))) {
            if (n.nodeType === 3 && !n.nodeValue.replace(/\s/g, '') && !run) { doc.removeChild(n); return; }
            if (!run) { run = document.createElement('p'); doc.insertBefore(run, n); }
            run.appendChild(n);
        } else {
            run = null;
            if (n.tagName === 'DIV' && !n.classList.contains('dw-pb') && !n.classList.contains('dw-toc')) {
                var p = document.createElement('p');
                if (n.getAttribute('style')) p.setAttribute('style', n.getAttribute('style'));
                while (n.firstChild) p.appendChild(n.firstChild);
                doc.replaceChild(p, n);
            }
        }
    });
    if (!doc.firstChild) doc.innerHTML = '<p><br></p>';
    // Разрыв страницы последним — после него должно быть куда поставить каретку.
    var last = doc.lastElementChild;
    if (last && (last.classList.contains('dw-pb') || last.tagName === 'TABLE' || last.tagName === 'HR')) {
        var np = document.createElement('p'); np.innerHTML = '<br>'; doc.appendChild(np);
    }
    doc.setAttribute('data-empty', isEmptyDoc() ? 'true' : 'false');
}

/* Любое изменение документа проходит здесь: нормализация, история, «есть
   несохранённое», подписчики (страницы, счётчики, структура, черновик). */
function afterChange(kind) {
    if (!S.composing) normalize();
    S.dirty = true;
    emit('change', kind || 'edit');
}

/* ── команды ────────────────────────────────────────────────────────────── */
/* Жирный, курсив, подчёркивание, списки — тегами (<b>, <i>, <u>, <ul>): чистый
   HTML, понятный и Word при вставке, и выгрузкам. Цвет, шрифт, кегль, фон —
   стилем (span style), тегов для них нет. */
var CSS_CMDS = { foreColor: 1, hiliteColor: 1, backColor: 1, fontName: 1, fontSize: 1 };
function execCmd(name, val) {
    try { document.execCommand('styleWithCSS', false, !!CSS_CMDS[name]); } catch (e) {}
    try { return document.execCommand(name, false, val == null ? null : val); } catch (e) { return false; }
}
/* Обёртка команды: каретка на месте → снимок до → действие → нормализация →
   снимок после. Каждая команда — один шаг отмены. */
function run(fn, kind) {
    restoreRange();
    if (H.timer) commit();
    var r;
    try { r = fn(); } catch (e) { report(e, 'cmd_' + (kind || '')); }
    afterChange(kind || 'cmd');
    commit();
    return r;
}
function curBlock(node) {
    var n = node || (selRange() || lastRange || {}).startContainer;
    while (n && n !== doc) {
        if (n.nodeType === 1 && /^(P|H1|H2|H3|H4|H5|H6|LI|BLOCKQUOTE|TD|TH|PRE)$/.test(n.tagName)) return n;
        n = n.parentNode;
    }
    return null;
}
function blocksInRange(r) {
    r = r || selRange() || lastRange;
    if (!r) return [];
    var out = [];
    var start = curBlock(r.startContainer), end = curBlock(r.endContainer);
    if (!start) return [];
    var walker = document.createTreeWalker(doc, NodeFilter.SHOW_ELEMENT, {
        acceptNode: function (n) { return /^(P|H1|H2|H3|H4|H5|H6|LI|BLOCKQUOTE|PRE)$/.test(n.tagName) ? 1 : 3; }
    });
    var n, on = false;
    while ((n = walker.nextNode())) {
        if (n === start) on = true;
        if (on) out.push(n);
        if (n === end) break;
    }
    if (!out.length) out.push(start);
    return out;
}

function setBlockStyle(v) {
    var tag = { p: 'p', h1: 'h1', h2: 'h2', h3: 'h3', quote: 'blockquote' }[v] || 'p';
    run(function () {
        var b = curBlock();
        if (b && b.tagName === 'LI') { execCmd(b.parentNode.tagName === 'OL' ? 'insertOrderedList' : 'insertUnorderedList'); }
        var cur = curBlock();
        if (cur && cur.tagName.toLowerCase() === tag && tag !== 'p') tag = 'p';
        execCmd('formatBlock', '<' + tag + '>');
    }, 'style');
}
function setFontSize(pt) {
    pt = Math.max(1, Math.min(400, Math.round(pt * 2) / 2));
    var r = restoreRange();
    if (r && r.collapsed) {
        // Каретка без выделения: кегль ляжет на то, что напечатают дальше.
        S.pendingSize = pt;
        run(function () { execCmd('fontSize', '7'); }, 'size');
        return;
    }
    S.pendingSize = pt;
    run(function () { execCmd('fontSize', '7'); }, 'size');
}
function stepFontSize(dir) {
    var cur = currentFormat().size || S.set.size;
    var list = C.sizes || [8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 72];
    var next = cur;
    if (dir > 0) { for (var i = 0; i < list.length; i++) if (list[i] > cur + 0.01) { next = list[i]; break; } if (next === cur) next = cur + 4; }
    else { for (var j = list.length - 1; j >= 0; j--) if (list[j] < cur - 0.01) { next = list[j]; break; } if (next === cur) next = Math.max(1, cur - 1); }
    setFontSize(next);
}
function setFont(id) {
    var f = FONTS[id]; if (!f) return;
    var r = restoreRange();
    if (r && !r.collapsed && r.toString().length > 0) {
        run(function () { execCmd('fontName', f.css.split(',')[0].replace(/['"]/g, '')); }, 'font');
        // fontName кладёт голое имя; заменяем на полный стек с метрической заменой
        doc.querySelectorAll('span[style*="font-family"]').forEach(function (sp) {
            var fam = sp.style.fontFamily.replace(/['"]/g, '').split(',')[0].trim();
            if (fam === f.name && sp.style.fontFamily.indexOf('DW ') === -1) sp.style.fontFamily = f.css;
        });
        commit();
        return;
    }
    // Без выделения — шрифт всего документа (так чаще и хотят: «сделать в Times»).
    run(function () { S.set.font = id; applySettings(); }, 'font_doc');
}
function setAlign(v) {
    var cmd = { left: 'justifyLeft', center: 'justifyCenter', right: 'justifyRight', justify: 'justifyFull' }[v] || 'justifyLeft';
    run(function () { execCmd(cmd); }, 'align');
}
function toggleList(ordered) {
    run(function () { execCmd(ordered ? 'insertOrderedList' : 'insertUnorderedList'); }, 'list');
}
function indent(dir) {
    var b = curBlock();
    if (b && b.closest('li')) { run(function () { execCmd(dir > 0 ? 'indent' : 'outdent'); }, 'indent'); return; }
    // Абзац вне списка: отступ полем слева, а не blockquote, которым браузер
    // «отступает» по умолчанию (blockquote у нас — цитата).
    run(function () {
        blocksInRange().forEach(function (el) {
            if (el.tagName === 'LI') return;
            var cur = parseFloat(el.style.marginInlineStart || el.style.marginLeft) || 0;
            var step = 1.25 * 37.795;
            var nv = Math.max(0, cur + dir * step);
            el.style.removeProperty('margin-left');
            if (nv > 0.5) el.style.marginInlineStart = nv.toFixed(1) + 'px'; else el.style.removeProperty('margin-inline-start');
            if (!el.getAttribute('style')) el.removeAttribute('style');
        });
    }, 'indent');
}
function setColor(c) { run(function () { execCmd('foreColor', c || '#000000'); if (!c) stripInline('color'); }, 'color'); }
function setMark(c) { run(function () { execCmd('hiliteColor', c || 'transparent'); }, 'mark'); }
/* «Цвет авто»: снять color со всех span в выделении (а не покрасить в чёрный —
   на тёмном листе чёрный исчез бы). */
function stripInline(prop) {
    var r = selRange(); if (!r) return;
    doc.querySelectorAll('span[style]').forEach(function (sp) {
        if (r.intersectsNode(sp)) sp.style.removeProperty(prop);
    });
}

function insertNodeAtCaret(node, after) {
    var r = restoreRange();
    if (!r) return;
    r.deleteContents();
    r.insertNode(node);
    var nr = document.createRange();
    if (after) { nr.setStartAfter(after); } else nr.setStartAfter(node);
    nr.collapse(true);
    var s = window.getSelection(); s.removeAllRanges(); s.addRange(nr);
}
/* Вставить блоки (таблица, разрыв, оглавление) — абзац под кареткой режется на
   два, блоки встают между половинами, пустые половины не остаются. */
function insertBlocks(html) {
    var r = restoreRange(); if (!r) return null;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var frag = document.createDocumentFragment(), firstNew = tmp.firstChild, lastNew = tmp.lastChild;
    while (tmp.firstChild) frag.appendChild(tmp.firstChild);
    var b = curBlock(r.startContainer);
    var top = b;
    while (top && top.parentNode !== doc) top = top.parentNode;
    if (!top) { doc.appendChild(frag); return lastNew; }
    if (top.tagName === 'TABLE' || top.tagName === 'UL' || top.tagName === 'OL') {
        top.parentNode.insertBefore(frag, top.nextSibling);
        return lastNew;
    }
    r.deleteContents();
    var tail = document.createRange();
    tail.setStart(r.startContainer, r.startOffset);
    tail.setEnd(top, top.childNodes.length);
    var rest = tail.extractContents();
    var second = top.cloneNode(false);
    second.appendChild(rest);
    var hasText = function (el) { return el.textContent.replace(/[\u200b\s]/g, '') || el.querySelector('img,br+*'); };
    top.parentNode.insertBefore(second, top.nextSibling);
    top.parentNode.insertBefore(frag, second);
    if (!hasText(top) && !top.querySelector('img')) top.parentNode.removeChild(top);
    if (!hasText(second) && !second.querySelector('img')) { second.innerHTML = '<br>'; }
    var s = window.getSelection(), nr = document.createRange();
    nr.setStart(second, 0); nr.collapse(true); s.removeAllRanges(); s.addRange(nr);
    return lastNew || firstNew;
}

function insertPageBreak() {
    run(function () {
        insertBlocks('<div class="dw-pb" contenteditable="false" data-label="' + esc(t('page_break')) + '"></div>');
    }, 'pagebreak');
}
function insertHr() { run(function () { insertBlocks('<hr>'); }, 'hr'); }
function insertTable(rows, cols) {
    rows = Math.max(1, Math.min(60, rows | 0)); cols = Math.max(1, Math.min(12, cols | 0));
    var h = '<table><tbody>';
    for (var r = 0; r < rows; r++) {
        h += '<tr>';
        for (var c = 0; c < cols; c++) h += r === 0 && rows > 1 ? '<th><br></th>' : '<td><br></td>';
        h += '</tr>';
    }
    h += '</tbody></table>';
    run(function () {
        var tbl = insertBlocks(h);
        var cell = tbl && tbl.querySelector && tbl.querySelector('th,td');
        if (cell) { var s = window.getSelection(), nr = document.createRange(); nr.setStart(cell, 0); nr.collapse(true); s.removeAllRanges(); s.addRange(nr); }
    }, 'table');
}
function insertText(txt) { run(function () { execCmd('insertText', txt); }, 'text'); }
function insertDate() {
    var d = new Date(), s;
    try {
        // ГОСТ Р 7.0.97-2025: «01 сентября 2025 г.»; в остальных языках — длинная дата языка.
        if (C.locale === 'ru') s = ('0' + d.getDate()).slice(-2) + ' ' + d.toLocaleDateString('ru', { month: 'long', day: 'numeric' }).replace(/^\d+\s/, '') + ' ' + d.getFullYear() + ' г.';
        else s = d.toLocaleDateString(C.locale, { year: 'numeric', month: 'long', day: 'numeric' });
    } catch (e) { s = d.toDateString(); }
    insertText(s);
}
function insertImageFile(file) {
    return adoptImageFile(file).then(function (url) {
        if (!url) { toast(t('img_bad'), 'error'); return; }
        run(function () {
            var img = document.createElement('img');
            img.src = url; img.alt = '';
            insertNodeAtCaret(img);
        }, 'image');
        track('image_insert', {});
    });
}

/* ── текущее форматирование под кареткой (для строки инструментов) ──────── */
function currentFormat() {
    var r = selRange() || lastRange;
    var out = { style: 'p', font: S.set.font, size: S.set.size, align: S.set.align === 'justify' ? 'justify' : 'left', inTable: false, inList: '', link: null };
    if (!r) return out;
    var n = r.startContainer.nodeType === 3 ? r.startContainer.parentNode : r.startContainer;
    if (r.startContainer.nodeType === 1 && r.startContainer.childNodes[r.startOffset] && r.startContainer.childNodes[r.startOffset].nodeType === 1) {
        n = r.startContainer.childNodes[r.startOffset];
    }
    if (!doc.contains(n)) return out;
    var cs = window.getComputedStyle(n.nodeType === 1 ? n : n.parentNode);
    out.size = Math.round(parseFloat(cs.fontSize) / PT * 2) / 2;
    var fam = cs.fontFamily.toLowerCase();
    for (var id in FONTS) {
        var nm = FONTS[id].name.toLowerCase();
        if (fam.indexOf(nm) === 0 || fam.indexOf("'" + nm) === 0 || fam.indexOf('"' + nm) === 0) { out.font = id; break; }
    }
    var b = curBlock(n);
    if (b) {
        var tg = b.tagName;
        out.style = tg === 'H1' ? 'h1' : tg === 'H2' ? 'h2' : tg === 'H3' ? 'h3' : tg === 'BLOCKQUOTE' || b.closest('blockquote') ? 'quote' : 'p';
        var ta = window.getComputedStyle(b).textAlign;
        out.align = ta === 'center' ? 'center' : ta === 'right' || (ta === 'end' && !C.rtl) ? 'right' : ta === 'justify' ? 'justify' : 'left';
        var li = b.closest('li');
        if (li) out.inList = li.parentNode.tagName === 'OL' ? 'ol' : 'ul';
        out.inTable = !!b.closest('td,th');
    }
    var a = n.closest && n.closest('a');
    if (a && doc.contains(a)) out.link = a;
    return out;
}
function qState(cmd) { try { return document.queryCommandState(cmd); } catch (e) { return false; } }

/* ── сериализация ───────────────────────────────────────────────────────── */
function cleanHtml(el) {
    var c = (el || doc).cloneNode(true);
    c.querySelectorAll('.dw-sel').forEach(function (x) { x.classList.remove('dw-sel'); if (!x.className) x.removeAttribute('class'); });
    return c.innerHTML;
}
/* Для черновика: blob:-адреса картинок → номера, байты — отдельным списком. */
function snapshotForSave() {
    var c = doc.cloneNode(true), files = [], map = {};
    c.querySelectorAll('img').forEach(function (img) {
        var src = img.getAttribute('src') || '';
        if (IMG[src]) {
            if (!(src in map)) { map[src] = files.length; files.push(IMG[src]); }
            img.setAttribute('src', 'dw-img:' + map[src]);
        }
    });
    c.querySelectorAll('.dw-sel').forEach(function (x) { x.classList.remove('dw-sel'); });
    return { html: c.innerHTML, files: files };
}
function loadHtml(html, files) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '<p><br></p>';
    tmp.querySelectorAll('img').forEach(function (img) {
        var m = /^dw-img:(\d+)$/.exec(img.getAttribute('src') || '');
        if (m) {
            var f = files && files[+m[1]];
            if (f) img.setAttribute('src', addImage(f)); else img.parentNode.removeChild(img);
        }
    });
    doc.innerHTML = tmp.innerHTML;
    normalize();
}

/* Текст документа целиком — для счётчиков и TXT. Блоки разделены переводом
   строки, разрыв страницы — пустой строкой. */
function plainText(el) {
    el = el || doc;
    var out = [];
    (function walk(n) {
        for (var c = n.firstChild; c; c = c.nextSibling) {
            if (c.nodeType === 3) { out.push(c.nodeValue.replace(/\u200b/g, '')); continue; }
            if (c.nodeType !== 1) continue;
            var tg = c.tagName;
            if (tg === 'BR') { out.push('\n'); continue; }
            if (c.classList && c.classList.contains('dw-pb')) { out.push('\n\n'); continue; }
            var block = /^(P|H1|H2|H3|H4|H5|H6|LI|BLOCKQUOTE|TR|DIV|PRE|HR)$/.test(tg);
            if (tg === 'TD' || tg === 'TH') { walk(c); out.push('\t'); continue; }
            walk(c);
            if (block) out.push('\n');
        }
    })(el);
    return out.join('').replace(/\t\n/g, '\n').replace(/\n{3,}/g, '\n\n').replace(/^\n+|\n+$/g, '');
}

var SEG = null;
try { SEG = window.Intl && Intl.Segmenter ? new Intl.Segmenter(C.locale, { granularity: 'word' }) : null; } catch (e) { SEG = null; }
/* Слова считаются так, как их делит сам язык (Intl.Segmenter): китайская фраза
   не одно слово, «из-за» — одно. Без Segmenter — по пробелам. */
function countWords(text) {
    if (!text || !text.trim()) return 0;
    if (SEG) {
        var n = 0, it = SEG.segment(text);
        for (var s = it[Symbol.iterator](), x = s.next(); !x.done; x = s.next()) if (x.value.isWordLike) n++;
        return n;
    }
    var m = text.match(/[\p{L}\p{N}][\p{L}\p{N}'’\-]*/gu);
    return m ? m.length : 0;
}
function textStats(text) {
    text = text == null ? plainText() : text;
    var words = countWords(text);
    var chars = text.replace(/\n/g, '').length;
    var charsNs = text.replace(/\s/g, '').length;
    var paras = text.split(/\n+/).filter(function (p) { return p.trim(); }).length;
    var sentences = (text.match(/[^.!?…。！？]+[.!?…。！？]+/g) || []).length || (text.trim() ? 1 : 0);
    var wpm = { ru: 180, uk: 180, en: 238, de: 220, fr: 215, es: 220, pt: 210, id: 200, ko: 200, ar: 180 }[C.locale] || 220;
    return { words: words, chars: chars, charsNs: charsNs, paras: paras, sentences: sentences,
        readMin: Math.max(words ? 1 : 0, Math.round(words / wpm)), speakMin: Math.max(words ? 1 : 0, Math.round(words / 130)) };
}

/* ── загрузка скриптов по требованию (адреса с версией — из блейда) ─────── */
var loaded = {};
function loadScript(urls) {
    urls = [].concat(urls || []);
    var key = urls.join('|');
    if (loaded[key]) return loaded[key];
    // Каждый адрес — две попытки (обрыв мобильной сети — не повод отказать),
    // потом следующий адрес (CDN → свой сервер).
    var tries = [];
    urls.forEach(function (u) { tries.push(u, u); });
    loaded[key] = new Promise(function (resolve, reject) {
        var i = 0;
        (function next() {
            if (i >= tries.length) { delete loaded[key]; reject(new Error('load_failed')); return; }
            var s = document.createElement('script');
            s.src = tries[i++]; s.async = true;
            var nonce = document.querySelector('script[nonce]');
            if (nonce && nonce.nonce) s.nonce = nonce.nonce;
            var settled = false;
            // сеть, которая молчит, — тоже отказ: без срока кнопка ждала бы вечно
            var guard = setTimeout(function () { if (!settled) { settled = true; s.remove(); next(); } }, 45000);
            s.onload = function () { if (settled) return; settled = true; clearTimeout(guard); resolve(); };
            s.onerror = function () { if (settled) return; settled = true; clearTimeout(guard); s.remove(); setTimeout(next, i % 2 ? 700 : 0); };
            document.head.appendChild(s);
        })();
    });
    return loaded[key];
}

/* Готовы ли шрифты листа — замер раскладки (страницы, PDF) до загрузки шрифта
   промахнулся бы на ширину запасного. Ожидание ограничено. */
function fontsReady(ms) {
    var fams = ['DW Tinos', 'DW Arimo', 'DW Carlito', 'DW Caladea', 'DW Cousine'];
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    var sample = 'AaЯя1';
    var jobs = [];
    var f = FONTS[S.set.font];
    var used = {};
    used[S.set.font] = 1;
    doc.querySelectorAll('[style*="font-family"]').forEach(function (n) {
        var fam = n.style.fontFamily.toLowerCase();
        for (var id in FONTS) if (fam.indexOf(FONTS[id].name.toLowerCase()) !== -1) used[id] = 1;
    });
    var map = { tnr: 'DW Tinos', arial: 'DW Arimo', calibri: 'DW Carlito', cambria: 'DW Caladea', courier: 'DW Cousine' };
    Object.keys(used).forEach(function (id) {
        var fam = map[id]; if (!fam) return;
        ['400 normal', '700 normal', '400 italic', '700 italic'].forEach(function (w) {
            var p = w.split(' ');
            jobs.push(document.fonts.load(p[1] + ' ' + p[0] + ' 16px "' + fam + '"', sample).catch(function () {}));
        });
    });
    void f; void fams;
    return Promise.race([Promise.all(jobs), new Promise(function (r) { setTimeout(r, ms || 3500); })]);
}

window.DW = {
    C: C, L: L, t: t, esc: esc, fmtNum: fmtNum, $: $, root: root, doc: doc,
    on: on, emit: emit, report: report, track: track, toast: toast,
    MM: MM, PT: PT, PAPER: PAPER, FONTS: FONTS, PRESETS: PRESETS, PRESET_ORDER: PRESET_ORDER, DEFAULT_PRESET: DEFAULT_PRESET,
    S: S, presetSettings: presetSettings, pageSizePx: pageSizePx, applySettings: applySettings,
    images: { add: addImage, blob: imageBlob, adoptFile: adoptImageFile, map: IMG },
    sel: { range: selRange, restore: restoreRange, save: saveSel, load: loadSel, last: function () { return lastRange; } },
    history: { commit: commit, schedule: scheduleCommit, undo: undo, redo: redo, reset: resetHistory, canUndo: canUndo, canRedo: canRedo },
    normalize: normalize, afterChange: afterChange, isEmptyDoc: isEmptyDoc,
    cmd: {
        exec: execCmd, run: run, style: setBlockStyle, size: setFontSize, stepSize: stepFontSize, font: setFont,
        align: setAlign, list: toggleList, indent: indent, color: setColor, mark: setMark,
        pageBreak: insertPageBreak, hr: insertHr, table: insertTable, text: insertText, date: insertDate,
        image: insertImageFile, insertBlocks: insertBlocks, insertNode: insertNodeAtCaret
    },
    curBlock: curBlock, blocksInRange: blocksInRange, currentFormat: currentFormat, qState: qState,
    cleanHtml: cleanHtml, snapshotForSave: snapshotForSave, loadHtml: loadHtml, plainText: plainText,
    countWords: countWords, textStats: textStats, loadScript: loadScript, fontsReady: fontsReady
};

try { document.execCommand('defaultParagraphSeparator', false, 'p'); } catch (e) {}
applySettings(true);
})();
